// 日志浏览系统处理,当有异常时不做任何提示
import axios from 'axios'
import Qs from 'qs'
import store from '@/store/index'
import router from '@/router/index'
// import fundebug from 'fundebug-javascript'
import { Message } from 'element-ui'
import $util from '@/utils/utils'
import $i18 from '@/utils/I18.js'
const fetch = axios.create({
  timeout: 1000,
  baseURL: process.env.VUE_APP_API_CUSTOMER_API
  // "Access-Control-Allow-Origin": "*" // 前端配置跨域请求头，一般配置代理
})

fetch.interceptors.request.use( // 请求拦截器
  config => {
    if (localStorage.getItem("accessToken")) {
      config.headers.Authorization = localStorage.getItem("accessToken")
      config.headers.language = localStorage.getItem("language") || 'zh'
      config.headers.website = $util.getCurrentWebSite();
      config.headers.unionKey = 'gt6';
      if (config.data) {
        config.data.token = localStorage.getItem("accessToken")
      } else {
        config.data = {
          token: localStorage.getItem("accessToken")
        }
      }
    }
    if (config.url.indexOf('api/centralconsole') < 0) {
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      // config.transformRequest = [function (data) {
      //   return Qs.stringify(data)
      // }]
    }
    return config
  },
  error => {
    // fundebug.notify(error)
    return Promise.reject(error)
  }
)

fetch.interceptors.response.use(
  response => {
    const res = response.data
    res.code = Number(res.code)
    if (res.code !== 200) {
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    if (error.response.status === 401) {
      
    } else {
      return Promise.reject(error)
    }
  }
)

export default fetch
